// extracted by mini-css-extract-plugin
module.exports = {"tags":"B_bW","tags__item":"B_bX"};